import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { openContact, showDynamicContact } from '@rendora/common/features/contact/index';
import { debounce } from 'lodash-es';

export { showDynamicContact };

export const showContact = debounce((name?: string) => {
  if (isChinese()) {
    openContact(getFeUrl(`/youyan-platform/png/qrcode/drainage/${name}.png`));
  } else {
    // 海外留资
    window.open('/contact-us');
  }
}, 200);

export const showContactNew = debounce((url?: string) => {
  if (isChinese() && url) {
    openContact(url);
  } else {
    // 海外留资
    window.open('/contact-us');
  }
}, 200);

export const subscribeContact = () => {
  showDynamicContact(PositionCode['有言官套餐网权益页面专属定制']);
};
